export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/patrick-tomasso-9ab45f3d79c3da1ba23cc71fe2524450.jpg";